import api from '../../api/api'

const state = {
  all: []
}

// getters
const getters = {}

// actions
const actions = {
  getAllTourTemplates ({ commit }) {
    api.getTourTemplates(tourTemplates => {
      commit('setTourTemplates', tourTemplates)
    })
  },
  addTourTemplate (context, tour) {
    return api.addTourTemplate(tour, function (data) {
      context.commit('getAllTourTemplates')
    })
  },
  updateTourTemplate (context, tour) {
    return api.updateTourTemplate(tour, function (data) {
      context.commit('getAllTourTemplates')
    })
  },
  deleteTourTemplate (context, tour) {
    return api.deleteTourTemplate(tour, function (data) {
      context.commit('getAllTourTemplates')
    })
  }
}

const mutations = {
  setTourTemplates (state, tourTemplates) {
    state.all = tourTemplates
  },
  updateTourTemplate (state, tour) {
    this.dispatch('updateTourTemplate', tour)
  },
  addTourTemplate (state, options) {
    this.dispatch('addTourTemplate', options)
  },
  deleteTourTemplate (state, tour) {
    this.dispatch('deleteTourTemplate', tour)
  },
  getAllTourTemplates () {
    this.dispatch('getAllTourTemplates')
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/tourTemplate.js